import {
    CheckoutAPIProduct,
    isCheckoutAPIProduct,
    isFullRelatedProduct,
    RelatedProduct
} from "@/types/centra/checkout-api/products/post-products"

export default function extractProducts(data: CheckoutAPIProduct): RelatedProduct[] {
    if (!data) return []

    const relatedProductsWithVariantRelation: RelatedProduct[] = []
    const seenProducts = new Set<string>()

    // Process related products
    if (data.relatedProducts && data.relatedProducts.length > 0) {
        data.relatedProducts.forEach(relatedProduct => {
            if (
                isFullRelatedProduct(relatedProduct) ||
                isCheckoutAPIProduct(relatedProduct)
            ) {
                const relatedProductIdentifier = `${relatedProduct.sku}-${relatedProduct.uri}`

                // Add related product if it has a 'variant' relation, hasn't been added yet, and price is not null
                if (
                    relatedProduct.relation === "variant" &&
                    !seenProducts.has(relatedProductIdentifier) &&
                    relatedProduct.price !== null
                ) {
                    // Ensure the item is a RelatedProduct before adding
                    if (!isCheckoutAPIProduct(relatedProduct)) {
                        relatedProductsWithVariantRelation.push(relatedProduct)
                        seenProducts.add(relatedProductIdentifier)
                    }
                }
            }
        })
    }

    return relatedProductsWithVariantRelation
}
